/* The free MBA Tools Workbook on the product and home pages (16 Oct 2026): badges, the Workbook next to the toolkit
   cards, the line above Add to cart. sections/bd-workbook-bonus.liquid writes the settings
   (script[data-bd-wb-bonus-config]) and loads this file with defer (SPEED-11: no longer inline at the top of every page).
   PRICE-01 (17 Oct 2026): no struck-through prices any more (the "bought separately" €148 / €228 were never asked).
   PRICE-02 (17 Oct 2026): the top buy row's content line follows the chosen format; under Add to cart the free
   Workbook and one short comparison. */
(function () {
  var cfgEl = document.querySelector('script[data-bd-wb-bonus-config]'), C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  function list(v) { return (v || []).map(function (h) { return String(h).trim(); }); }
  var handles = list(C.handles);
  var tagHtml = C.card_text;
  var addonImg = C.addon_image_url;
  var addonNote = C.addon_note, addonStrike = C.addon_strike || '';
  var addonLabel = C.addon_label || 'FREE Workbook';
  // VAT-06 (22 Oct 2026, QA P2-3): digital-only formats (not in physical_handles) get "(VAT included)" instead of "(VAT and shipping included)"
  var vatNote = C.vat_note, vatNoteDigital = C.vat_note_digital || C.vat_note;
  var buyNotePhysical = C.buy_note_physical;
  var buyNoteDigital = C.buy_note_digital;
  var physicalHandles = list(C.physical_handles);
  // PLUS-01 (22 Oct 2026, owner): a golden plus between the product and the Workbook, so no "+" before the title
  var heroFree = C.hero_free !== false, heroFreeTitle = String(C.hero_free_title || '').replace(/^\s*\+\s*/, ''), heroFreeNote = C.hero_free_note || '';
  var selectedBadge = C.selected_badge === true;
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.5 9.5 17.5 19.5 6.5"/></svg>';
  // ACCESS-02 (22 Oct 2026, owner): say what is online, so the printed deck never reads like a digital product
  var accessByHandle = { 'mba-tools': C.access_physical || C.access_note || '', 'complete-package': C.access_complete || C.access_note || '' };
  var deliveryTo = C.delivery_to || '';
  var LAPTOP = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"/></svg>';
  var RECEIPT = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>';
  var SHIELD = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
  function returnsText() { var t = window.BD_V149 && window.BD_V149.trust; return (t && typeof t.physical === 'string' && t.physical) || '30 days to return the deck'; }
  var SHUTTLE = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>';
  function selectedHandle(root) {
    var card = root.querySelector('[data-bdp-card][aria-pressed="true"]');
    return card ? card.getAttribute('data-product-handle') || '' : '';
  }
  /* "Free and fast delivery · VAT included" above the quantity and the Add to cart button; digital-only formats get
     their own line ("Instant access · VAT included") */
  function buyNote(root) {
    var row = root.querySelector('.bdp-buyrow');
    if (!row) return;
    var physical = physicalHandles.indexOf(selectedHandle(root)) !== -1;
    var text = physical ? buyNotePhysical : buyNoteDigital;
    var el = row.querySelector(':scope > [data-bd-buy-note]');
    var vat = row.querySelector(':scope > [data-bd-vat-note]');
    if (!text) { if (el) el.remove(); if (vat) vat.remove(); return; }
    // VAT-05 (22 Oct 2026, owner): the first part ("Free and fast delivery" / "Instant access") on its own line with a
    // shuttle (printed) or laptop (digital), the rest ("VAT included") on its own line with a receipt icon
    var parts = text.split('·').map(function (x) { return x.trim(); }).filter(Boolean);
    var main = parts.shift() || '', rest = parts.join(' · ');
    var kind = physical ? 'p' : 'd';
    if (!el) {
      el = document.createElement('p');
      el.className = 'bd-buy-note';
      el.setAttribute('data-bd-buy-note', '');
      row.insertBefore(el, row.firstChild);
    } else if (el !== row.firstElementChild && !(row.firstElementChild && row.firstElementChild.hasAttribute('data-bd-access-note') && row.firstElementChild.nextElementSibling === el)) {
      row.insertBefore(el, row.firstChild);
    }
    // printed formats: the visitor's country flag of the shipping line below (which then hides, see the CSS)
    var flagEl = physical ? root.querySelector('.bdp-selected__ticks li[data-bd-flag] .bdp-tick__flag') : null;
    var flag = flagEl ? flagEl.textContent.trim() : '';
    var sig = kind + '|' + flag + '|' + text;
    if (el.getAttribute('data-bd-buy-note') !== sig) {
      el.setAttribute('data-bd-buy-note', sig);
      // FLAG-02 (22 Oct 2026, owner): "Free and fast delivery to 🇳🇱": the flag after the text
      el.innerHTML = (physical ? SHUTTLE : LAPTOP) + '<span class="bd-buy-note__text"></span><span class="bd-buy-note__flag"></span>';
      el.querySelector('.bd-buy-note__text').textContent = main + (flag && deliveryTo ? ' ' + deliveryTo : '');
      el.querySelector('.bd-buy-note__flag').textContent = flag;
    }
    // RETURNS-04 (22 Oct 2026, owner): printed formats end the green lines with the 30-day return line
    var ret = row.querySelector(':scope > [data-bd-return-note]');
    if (physical) {
      if (!ret) {
        ret = document.createElement('p');
        ret.className = 'bd-buy-note bd-buy-note--return';
        ret.setAttribute('data-bd-return-note', '');
        ret.innerHTML = SHIELD + '<span class="bd-buy-note__text"></span>';
        ret.querySelector('.bd-buy-note__text').textContent = returnsText();
      }
    } else if (ret) { ret.remove(); ret = null; }
    if (!rest) { if (vat) vat.remove(); if (ret && el.nextSibling !== ret) row.insertBefore(ret, el.nextSibling); return; }
    if (!vat) {
      vat = document.createElement('p');
      vat.className = 'bd-buy-note bd-buy-note--vat';
      vat.setAttribute('data-bd-vat-note', '');
      vat.innerHTML = RECEIPT + '<span class="bd-buy-note__text"></span>';
    }
    if (vat.querySelector('.bd-buy-note__text').textContent !== rest) vat.querySelector('.bd-buy-note__text').textContent = rest;
    if (el.nextSibling !== vat) row.insertBefore(vat, el.nextSibling);
    if (ret && vat.nextSibling !== ret) row.insertBefore(ret, vat.nextSibling);
  }
  /* ACCESS-01 (22 Oct 2026, owner): every order comes with instant online access (the online Workbook), so printed
     formats get their own line with a laptop icon, right above the delivery line (digital formats already say so) */
  function accessNote(root) {
    var row = root.querySelector('.bdp-buyrow');
    if (!row) return;
    var physical = physicalHandles.indexOf(selectedHandle(root)) !== -1;
    var el = row.querySelector(':scope > [data-bd-access-note]');
    var accessText = accessByHandle[selectedHandle(root)] || '';
    if (!physical || !accessText) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'bd-buy-note bd-buy-note--access';
      el.setAttribute('data-bd-access-note', '');
      el.innerHTML = LAPTOP + '<span class="bd-buy-note__text"></span>';
    }
    if (el.querySelector('.bd-buy-note__text').textContent !== accessText) el.querySelector('.bd-buy-note__text').textContent = accessText;
    var note = row.querySelector(':scope > [data-bd-buy-note]');
    var before = note || row.firstChild;
    if (el.parentNode !== row || el.nextSibling !== before) row.insertBefore(el, before);
  }
  /* PRICE-02: under the top buy row one line with what the chosen format contains (the hero section writes the line
     of the page's own product and all lines in data-bd-lines); it follows the format chosen in the buy block */
  function heroLine(root) {
    var h = selectedHandle(root);
    if (!h) return;
    document.querySelectorAll('[data-bd-hero-line]').forEach(function (el) {
      if (el.getAttribute('data-handle') === h) return;
      var lines;
      try { lines = JSON.parse(el.getAttribute('data-bd-lines') || '{}'); } catch (e) { return; }
      el.setAttribute('data-handle', h);
      // LINE-04: an empty line in the section settings = no line for that format
      el.hidden = !lines[h];
      el.textContent = lines[h] || '';
    });
  }
  /* PRICE-02: under Add to cart of the buy block the free Workbook and one short comparison: the block is in the offer
     grid's HTML (data-bd-wb, data-bd-cmp); here only its texts follow the chosen format */
  function buyValue(root) {
    var el = root.querySelector('[data-bd-buy-value]');
    var h = selectedHandle(root);
    if (!el || !h || el.getAttribute('data-handle') === h) return;
    var cmpAll;
    try { cmpAll = JSON.parse(el.getAttribute('data-bd-cmp') || '{}'); } catch (e) { cmpAll = {}; }
    var wb = wanted(h) ? el.getAttribute('data-bd-wb') || '' : '', cmp = cmpAll[h] || '';
    el.setAttribute('data-handle', h);
    el.hidden = !wb && !cmp;
    var w = el.querySelector('.bd-buy-value__wb'), img = w.querySelector('img');
    w.innerHTML = wb; // STRIKE-02: the theme's own line, with the price struck through
    if (wb && img) w.insertBefore(img, w.firstChild);
    else if (wb && addonImg) w.insertAdjacentHTML('afterbegin', '<img src="' + addonImg + '" alt="" width="16" height="23" loading="lazy" decoding="async">');
    el.querySelector('.bd-buy-value__cmp').textContent = cmp;
  }
  /* the free Workbook next to the top Add to cart (phones and desktop), for the formats that come with it */
  function heroFreeTag(root) {
    var on = heroFree && heroFreeTitle && wanted(selectedHandle(root));
    document.querySelectorAll('.bd-hero-buy').forEach(function (form) {
      var btn = form.querySelector('.bd-hero-buy__btn'), el = form.querySelector('.bd-wb-herofree'), slot = form.querySelector('[data-bd-hero-bonus]');
      if (!on || !btn) { if (el) el.remove(); return; }
      if (el) return;
      el = document.createElement('span');
      el.className = 'bd-wb-herofree';
      el.innerHTML = '<span class="bd-wb-heroplus" aria-hidden="true">' + PLUS + '</span>' + (addonImg ? '<img src="' + addonImg + '" alt="" width="366" height="520" decoding="async">' : '') +
        '<span class="bd-wb-herofree__text"><span class="bd-wb-herofree__title"></span>' +
        (heroFreeNote ? '<span class="bd-wb-herofree__note">' + heroFreeNote + '</span>' : '') + '</span>';
      el.querySelector('.bd-wb-herofree__title').textContent = heroFreeTitle;
      // HERO-ROW: in its own place between the chosen product and the button (older hero markup: after the button)
      if (slot) slot.appendChild(el); else btn.parentNode.insertBefore(el, btn.nextSibling);
    });
  }
  /* HERO-ROW: the top buy row shows the chosen format (name and picture), following the choice in the buy block */
  function heroProduct(root) {
    var card = root.querySelector('[data-bdp-card][aria-pressed="true"]');
    if (!card) return;
    var h = card.getAttribute('data-product-handle') || '';
    var nameEl = card.querySelector('.bdp-product-card__title-text');
    var name = nameEl ? nameEl.textContent.trim() : '';
    document.querySelectorAll('[data-bd-hero-product]').forEach(function (box) {
      var n = box.querySelector('[data-bd-hero-name]');
      if (n && name && n.textContent !== name) n.textContent = name;
      if (box.getAttribute('data-handle') === h) return;
      box.setAttribute('data-handle', h);
      var src = '', tileImg = root.querySelector('.bdp-mtile[data-bdp-mtile="' + h + '"] .bdp-mtile__image'), cardImg = card.querySelector('.bdp-product-card__image');
      if (tileImg) src = tileImg.getAttribute('src') || tileImg.currentSrc || '';
      if (!src && cardImg) src = cardImg.currentSrc || cardImg.getAttribute('src') || '';
      var thumb = box.querySelector('.bd-hero-buy__thumb');
      if (!thumb || !src) return;
      var img = thumb.querySelector('img');
      if (!img) { img = document.createElement('img'); img.width = 52; img.height = 52; img.alt = ''; img.decoding = 'async'; thumb.appendChild(img); }
      img.removeAttribute('srcset');
      img.src = src;
    });
  }
  function vat(price, h) {
    if (!vatNote || !price || price.querySelector('.bd-wb-vat')) return;
    var n = document.createElement('span');
    n.className = 'bd-wb-vat';
    n.textContent = h && physicalHandles.indexOf(h) === -1 ? vatNoteDigital : vatNote;
    price.appendChild(n);
  }
  var template = document.querySelector('template[data-bd-wb-bonus-badge]');
  var PLUS = '<svg viewBox="0 0 40 40" aria-hidden="true"><defs><linearGradient id="bdWbGold" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#FFE48A"/><stop offset=".45" stop-color="#F2B92E"/><stop offset="1" stop-color="#B97A06"/></linearGradient></defs>' +
    '<path d="M15 4h10v11h11v10H25v11H15V25H4V15h11z" fill="url(#bdWbGold)" stroke="#fff" stroke-width="2.4" stroke-linejoin="round"/></svg>';
  function wanted(h) { return handles.indexOf(h) !== -1; }
  function cards(root) {
    root.querySelectorAll('[data-bdp-card]').forEach(function (card) {
      vat(card.querySelector('.bdp-product-card__price'), card.getAttribute('data-product-handle') || '');
      if (!wanted(card.getAttribute('data-product-handle') || '')) return;
      var body = card.querySelector('.bdp-product-card__body');
      if (tagHtml && body && !body.querySelector('.bd-wb-bonus-tag')) {
        var tag = document.createElement('span');
        tag.className = 'bd-wb-bonus-tag';
        tag.innerHTML = tagHtml;
        body.appendChild(tag);
      }
      if (addonImg && body && !body.querySelector('.bd-wb-addon')) {
        var add = document.createElement('span');
        add.className = 'bd-wb-addon';
        add.innerHTML = PLUS + '<img src="' + addonImg + '" alt="The MBA Tools Workbook" width="366" height="520" loading="lazy">' +
          (addonNote ? '<span class="bd-wb-addon__note">' + addonNote + '</span>' : '');
        // the Workbook's name next to the box, shown on phones only (there the row is box + name + "worth €29")
        var label = document.createElement('span');
        label.className = 'bd-wb-addon__label';
        label.textContent = addonLabel;
        add.insertBefore(label, add.querySelector('.bd-wb-addon__note'));
        body.appendChild(add);
      }
    });
  }
  function badge(root) {
    var box = root.querySelector('[data-bdp-selected-badges]');
    if (!box || !template) return;
    if (!selectedBadge) { var old = box.querySelector('[data-bd-wb-bonus-slot]'); if (old) old.remove(); return; }
    var card = root.querySelector('[data-bdp-card][aria-pressed="true"]');
    var on = Boolean(card) && wanted(card.getAttribute('data-product-handle') || '');
    var slot = box.querySelector('[data-bd-wb-bonus-slot]');
    if (on && !slot) box.appendChild(template.content.firstElementChild.cloneNode(true));
    if (!on && slot) slot.remove();
  }
  /* home page: the toolkit chooser's cards (desktop and mobile), found by their product link */
  function homeCards() {
    document.querySelectorAll('.bd-v34-card, .bd-v34-mobile-card').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var h = link ? (link.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0] : '';
      vat(card.querySelector('.bd-v34-card__price, .bd-v34-mobile-card__price'), h);
      if (!wanted(h)) return;
      var price = card.querySelector('.bd-v34-card__price, .bd-v34-mobile-card__price');
      if (!price || card.querySelector('.bd-wb-homebadge-row')) return;
      var row = document.createElement('div');
      row.className = 'bd-wb-homebadge-row';
      row.innerHTML = '<span class="bd-wb-homebadge">' + (addonImg ? '<img src="' + addonImg + '" alt="" width="366" height="520" loading="lazy">' : '') +
        // STRIKE-02: "+ FREE Workbook €29" with the price struck through, the title in the visitor's language
        '+ ' + heroFreeTitle + (addonStrike ? ' <em>' + addonStrike + '</em>' : '') + '</span>';
      price.parentNode.insertBefore(row, price.nextSibling);
    });
  }
  function init() {
    homeCards();
    document.querySelectorAll('[data-bdp-offer-grid]').forEach(function (root) {
      function sync() { cards(root); badge(root); buyNote(root); accessNote(root); buyValue(root); heroProduct(root); heroLine(root); heroFreeTag(root); }
      sync();
      new MutationObserver(sync).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
